<template>
  <bk-page v-if="!showSuccessFlag" class="e-invoicePage" :loading="!orderInfo || submitFlag" pageType="navPage" :navBarInfo="navBarInfo">

    <template #slot-rightItems>
      <bk-view class="view-languageName" @click="showSubPageWitType('LanguageConfig')">
        <bk-icon icon="icon-Language"></bk-icon>{{languageName}}
      </bk-view>
    </template>

    <bk-view class="view-form">
      <EInvoiceOrderInfo v-if="orderInfo" :showPriceUnit="showPriceUnit" :order-info="orderInfo"></EInvoiceOrderInfo>

      <bk-view class="view-nationality">

        <bk-view class="view-title">
          <bk-title class="must" lang-code="e_invoice_text_nationality"></bk-title>
        </bk-view>

        <bk-view class="view-customerType">

          <bk-view class="view-customerTypeItem" :class="customerInfo.customerType == item.key ? 'select' : ''" v-for="item in customerTypeList" @click="customerTypeChange(item.key)">
            <bk-lang :code="item.langCode"></bk-lang>
          </bk-view>

        </bk-view>

<!--        马来人-->
        <bk-view v-if="customerInfo.customerType == 0" class="view-formGroup view-idInfo">

          <bk-view class="view-formItem">
            <bk-select v-model:value="customerInfo.idType" size="full" :data-list="idTypeList"></bk-select>
          </bk-view>

          <bk-view class="view-formItem">
            <bk-input v-model:value="customerInfo.idValue" showFocusStatus size="full" :placeholder="idValueTipText"></bk-input>
          </bk-view>

          <bk-view class="view-formItem">
            <bk-input v-model:value="customerInfo.tin" showFocusStatus size="full" lang-code_placeholder="e_invoice_text_taxIdentificationNoTip"></bk-input>
          </bk-view>

        </bk-view>

<!--        外国人-->
        <bk-view v-else class="view-formGroup view-idInfo">

          <bk-view class="view-formItem foreigner-TIN">
<!--            <bk-view class="view-tipText">-->
<!--              <bk-lang code="e_invoice_text_taxIdentificationNo"></bk-lang>-->
<!--            </bk-view>-->
            <bk-input label-type="def" value="EI00000000020" disabled="" showFocusStatus size="full" lang-code_label="e_invoice_text_taxIdentificationNo"></bk-input>
          </bk-view>

          <bk-view class="view-formItem">
            <bk-input v-model:value="customerInfo.idValue" showFocusStatus size="full" lang-code_placeholder="e_invoice_text_passportNoTip"></bk-input>
          </bk-view>

        </bk-view>


      </bk-view>

      <bk-view class="view-personalDetails">

        <bk-view class="view-title">
          <bk-title class="must" lang-code="e_invoice_text_personalDetails"></bk-title>
        </bk-view>

        <bk-view class="view-formGroup view-personalInfo">

          <bk-view class="view-formItem">
            <bk-input v-model:value="customerInfo.registrationName" showFocusStatus size="full" lang-code_placeholder="e_invoice_text_name"></bk-input>
          </bk-view>

          <bk-view class="view-formItem">

            <PhoneInput
                :dataList="dictInfo.intMobileCd"
                v-model="customerInfo.telephone"
                langCode_placeholder=""
                v-model:intMobileCd="customerInfo.intMobileCd"
                v-model:intMobileCode="customerInfo.intMobileCode"
            />
          </bk-view>

          <bk-view class="view-formItem">
            <bk-input v-model:value="customerInfo.electronicMail" showFocusStatus size="full" lang-code_placeholder="e_invoice_text_emailAddress"></bk-input>
          </bk-view>

          <bk-view class="view-emailTip">
            <bk-lang code="e_invoice_text_emailTip"></bk-lang>
          </bk-view>

        </bk-view>


      </bk-view>

      <bk-view class="view-address">

        <bk-view class="view-title">
          <bk-title class="must" lang-code="e_invoice_text_address"></bk-title>
        </bk-view>

        <bk-view class="view-formGroup view-address">

          <bk-view class="view-formItem">
            <bk-input v-model:value="customerInfo.postalAddress.addressLine0" showFocusStatus size="full" lang-code_placeholder="e_invoice_text_address1"></bk-input>
          </bk-view>

          <bk-view class="view-formItem">
            <bk-input v-model:value="customerInfo.postalAddress.addressLine1" showFocusStatus size="full" lang-code_placeholder="e_invoice_text_address2"></bk-input>
          </bk-view>

          <bk-view class="view-formItem">
            <bk-input v-model:value="customerInfo.postalAddress.addressLine2" showFocusStatus size="full" lang-code_placeholder="e_invoice_text_address3"></bk-input>
          </bk-view>

          <bk-view class="view-formItem">
            <bk-input v-model:value="customerInfo.postalAddress.postalZone" showFocusStatus size="full" lang-code_placeholder="e_invoice_text_postcode"></bk-input>
            <bk-input v-model:value="customerInfo.postalAddress.cityName" showFocusStatus size="full" lang-code_placeholder="e_invoice_text_city"></bk-input>
          </bk-view>

          <bk-view class="view-formItem">
            <bk-select v-model:value="customerInfo.postalAddress.country" size="full" :data-list="countryList"></bk-select>
          </bk-view>

          <bk-view class="view-formItem">
            <bk-select v-model:value="customerInfo.postalAddress.countrySubentityCode" size="full" :data-list="stateList" lang-code_placeholder="e_invoice_text_state"></bk-select>
          </bk-view>


        </bk-view>


      </bk-view>

      <bk-view class="view-sstDetails">

        <bk-view class="view-title">
          <bk-title lang-code="e_invoice_text_sstDetail"></bk-title>
        </bk-view>

        <bk-view class="view-formGroup view-sstDetailInfo">

          <bk-view class="view-formItem">
            <bk-input v-model:value="customerInfo.sst" showFocusStatus size="full" lang-code_placeholder="e_invoice_text_sstDetailTip"></bk-input>
          </bk-view>

        </bk-view>


      </bk-view>

    </bk-view>

    <bk-view class="view-bottom">
      <bk-button lang-code="e_invoice_text_submit" size="full" @click="submitBtnClick"></bk-button>
    </bk-view>


    <transition name="rightFadeIn">

      <LanguageConfig v-if="subPage == 'LanguageConfig'" reloadPath="reload" pageType="navPage" @close="showSubPageWitType(undefined)"></LanguageConfig>

    </transition>


  </bk-page>


  <bk-page v-else class="e-invoicePage" pageType="navPage" :navBarInfo="navBarInfo">

    <bk-view class="view-success">

      <bk-view class="view-title">
        <bk-title font-size="24px" lang-code="e_invoice_text_submitSuccess"></bk-title>
      </bk-view>

    </bk-view>

  </bk-page>

</template>

<script>

	import {connectReq, baseReq} from '../../reqService';

	import EInvoiceOrderInfo from './subviews/e-invoiceOrderInfo/e-invoiceOrderInfo.vue';
	import PhoneInput from '/src/pages/login/signup/phoneInput/phoneInput.vue';
	import LanguageConfig from '/src/pages/userInfo/subPages/languageConfig/languageConfig.vue';

	export default {
		name: 'e-invoice',
		components:{
			PhoneInput,
			EInvoiceOrderInfo,
			LanguageConfig
		},
		computed: {
			idValueTipText () {

				let {idTypeList, customerInfo} = this;

				let item = this.$bk_findObjInList(idTypeList, 'key', customerInfo.idType);

				bkLog.log('idTypeList:::', item, item?.label);

				if (!item) {
					return '';
				}
        
				return this.$bk_getTextWithLangCode(item.langCode);
			},
			showPriceUnit () {

				let {dictInfo, compInfo} = this;

				if (!compInfo || !dictInfo || !dictInfo.currency) {
					return '';
				}

				let item = dictInfo.currency.filter(function (obj) {
					return obj.code == compInfo.currency;
				})[0];

				return item ? item.description : '';
			},
		},
		data (){

			let orlanguage = navigator.language.toLowerCase();

			let language = this.$bk_Global.languageTypeList.find((item) => {
				let bcp47 = item.bcp47?.toLowerCase();
				if(orlanguage=== bcp47){
					return true;
				}
				return orlanguage.split('-')[1].toUpperCase() === bcp47.split('-')[1].toUpperCase();
			})?.key || 'en';

			if (localStorage.getItem('LanguageType') && localStorage.getItem('LanguageType') != '') {
				language = localStorage.getItem('LanguageType');
			}

			let langItem = this.$bk_findItem(this.$bk_Global.languageTypeList, language, 'key');

			let languageName = langItem?.label || 'English';

			let stateList = [

				{
					'Code': '01',
					'State': 'Johor'
				},
				{
					'Code': '02',
					'State': 'Kedah'
				},
				{
					'Code': '03',
					'State': 'Kelantan'
				},
				{
					'Code': '04',
					'State': 'Melaka'
				},
				{
					'Code': '05',
					'State': 'Negeri Sembilan'
				},
				{
					'Code': '06',
					'State': 'Pahang'
				},
				{
					'Code': '07',
					'State': 'Pulau Pinang'
				},
				{
					'Code': '08',
					'State': 'Perak'
				},
				{
					'Code': '09',
					'State': 'Perlis'
				},
				{
					'Code': '10',
					'State': 'Selangor'
				},
				{
					'Code': '11',
					'State': 'Terengganu'
				},
				{
					'Code': '12',
					'State': 'Sabah'
				},
				{
					'Code': '13',
					'State': 'Sarawak'
				},
				{
					'Code': '14',
					'State': 'Wilayah Persekutuan Kuala Lumpur'
				},
				{
					'Code': '15',
					'State': 'Wilayah Persekutuan Labuan'
				},
				{
					'Code': '16',
					'State': 'Wilayah Persekutuan Putrajaya'
				},
				{
					'Code': '17',
					'State': 'Not Applicable'
				}
			];

			stateList.map(function (obj) {
				obj.key = obj.Code;
				obj.label = obj.State;
			});

			this.$bk_switchLang(language);

			return {
				id: this.$route.query.id,
				navBarInfo: {
					langCode_title:'e_invoice_title',
					backFlag: false,
				},
				orderInfo: undefined,
				einvoiceInfo: undefined,
				submitFlag: false,
				showSuccessFlag: false,

				orlanguage,
				languageName,
				dictInfo: {},
				compInfo: undefined,

				subPage: undefined,

				customerTypeList: [
					{key: 0, langCode: 'e_invoice_text_malaysian'},
					{key: 1, langCode: 'e_invoice_text_foreigner'},
				],

				customerInfo: {
					customerType: 0,
					idType: 'NRIC',
					idValue: '', // brn
					tin: '', // 税号

					registrationName: '',
					telephone: '',
					intMobileCd: '+60',
					intMobileCode: 'ID',
					electronicMail: '', // 邮箱

					postalAddress: {
						cityName: '',
						postalZone: '',
						countrySubentityCode: undefined,
						country: 'MYS',
						addressLine0: '',
						addressLine1: '',
						addressLine2: '',
					}
				},

				countryList: [
					{
						key: 'MYS',
						label: 'Malaysia',
						langCode: 'e_invoice_text_country_MYS',
						'Code': 'MYS',
						'Country': 'Malaysia'
					},
				],
				stateList,

				idTypeList: [
					{key: 'NRIC', label: 'Identification Card No.', langCode: 'e_invoice_text_idType_NRIC'},
					{key: 'PASSPORT', label: 'Passport No.', langCode: 'e_invoice_text_idType_PASSPORT'},
					{key: 'BRN', label: 'Business Registration No.', langCode: 'e_invoice_text_idType_BRN'},
					{key: 'ARMY', label: 'Army No.', langCode: 'e_invoice_text_idType_ARMY'}
				],
			};
		},
		created (){

			let token = this.$bk_getAccessToken();

			console.log('ViewToken', token);

			if (!token || token == '') {
				window.viewCallback = function () {
					console.log('调用viewCallback:', window.viewCallback);

					this.initData();
				}.bind(this);


				console.log('初始化window.viewCallback:', window.viewCallback);

				return;
			}

			this.initData();
		},
		methods:{
			async initData (){


				this.requestGetOrderInfo();
				this.requestGetDictInfo();
			},

			customerTypeChange (key) {

				this.customerInfo.customerType = key;
			},

			showSubPageWitType (type) {

				bkLog.log('LanguageConfig:::', type);
				this.subPage = type;
			},

			authSubmitInfo () {

				let {customerInfo} = this;

				// if (!customerInfo || !customerInfo.idValue || customerInfo.idValue == '') {
				// 	this.$bk_message.error(this.idValueTipText + ' missing!');
				// 	return false;
				// }

				bkLog.log('CustomerInfo:::', customerInfo);

				if (!customerInfo.telephone || customerInfo.telephone == '') {
					this.$bk_message.error({langCode: 'e_invoice_text_enterPhoneNumber'});
					return false;
				}
				if (customerInfo.telephone.length < 8) {
					this.$bk_message.error({langCode: 'e_invoice_text_errorPhoneTip'});
					return false;
				}
				if (customerInfo.electronicMail && customerInfo.electronicMail.indexOf('@') == -1) {
					this.$bk_message.error({langCode: 'e_invoice_text_errorEmailTip'});
					return false;
				}

				if (!customerInfo.postalAddress || !customerInfo.postalAddress.addressLine0 || customerInfo.postalAddress.addressLine0 == '') {
					this.$bk_message.error({langCode: 'e_invoice_text_enterAddress'});
					return false;
				}

				if (!customerInfo.postalAddress || !customerInfo.postalAddress.cityName || customerInfo.postalAddress.cityName == '') {
					this.$bk_message.error({langCode: 'e_invoice_text_enterCity'});
					return false;
				}

				if (!customerInfo.postalAddress || !customerInfo.postalAddress.countrySubentityCode || customerInfo.postalAddress.countrySubentityCode == '') {
					this.$bk_message.error({langCode: 'e_invoice_text_enterState'});
					return false;
				}

				return true;
			},

			async submitBtnClick () {

				if (!this.authSubmitInfo()) {
          
					return;
				}
				if (this.submitFlag) {
					return;
				}

				this.submitFlag = true;

				let {orderInfo, customerInfo} = this;

				//     "customer":{
				//       "tin":"IG40023251000",   --买方 TIN     必须
				//     "brn":"910224145085",   --买家登记 / 身份证号码 / 护照号码   必须
				//   "sst":"C58708193070",    --买方 SST 注册号   必须
				//   "postalAddress":{
				//     "cityName":"KUALA LUMPUR",--城市   必须
				//     "postalZone":"52100",
				//         "countrySubentityCode":"14",--州   必须   这里也要转换
				//     "addressLine0":"A-5-6 PERMAI RIA CONDO",    --地址1  必须
				//     "addressLine1":"TAMAN BATU PERMAI JALAN IPOH BATU 5",  --地址2
				//     "addressLine2":"",
				//         "country":"MYS"    --这还是简称  必须
				//   },
				//   "registrationName":"GOH WEI KOK",--名字  必须
				//   "telephone":"0162066916",    -- 买方联系电话
				//   "electronicMail":"ttelephant.malaysia@gmail.com"
				// }
				// parame.customer.dType = 'PASSPORT';
				// parame.customer.tin = 'EI00000000020';

				bkLog.log('Submitting...', orderInfo, customerInfo);

				let parame = {
					custId: orderInfo.custId,
					compId: orderInfo.compId,
					idType: customerInfo.customerType == 1 ? 'PASSPORT' : customerInfo.idType,
					idValue: customerInfo.idValue,
					tin: customerInfo.customerType == 1 ? 'EI00000000020' :customerInfo.tin,
				};

				let res = true;

				if (customerInfo.customerType != 1) {
					res = await connectReq.requestGetAuthEInvoiceBaseInfo(this, parame).catch(() => {});
				}

				// this.submitFlag = true;
				if (!res) {
					this.submitFlag = false;
					return;
				}

				// 发起e-invoce
				bkLog.log('校验结果：', res);
				customerInfo.brn = customerInfo.idValue;

				this.requestPostSubmitEInvoicInfo();


				bkLog.log('submitBtnClick:');
			},

			async requestPostSubmitEInvoicInfo () {
				//

				let {orderInfo, customerInfo, einvoiceInfo} = this;

				let parame = {
          ...einvoiceInfo,
          customer: this.$bk_copy(customerInfo),
          custId: orderInfo.custId,
          compId: orderInfo.compId,
				};

				if (customerInfo.customerType == 1) { // 外国人
					parame.customer.idType = 'PASSPORT';
					parame.customer.tin = 'EI00000000020';
					if (!customerInfo.idValue || customerInfo.idValue == '') {
						parame.customer.brn = 'NA';
					}
				}

				console.log('parame:::', parame, customerInfo);

				let res = await connectReq.requestPostSubmitEInvoicInfo(this, parame).catch(() => {});

				this.submitFlag = false;

				if (res.error) {
					if (res.error && res.error.details && res.error.details[0] && res.error.details[0].message) {
						this.$bk_message.error(res.error.details[0].message);
					}
					return;
				}

				bkLog.log('提交的结果：', res);
				this.showSuccessFlag = true;
			},

			async requestGetOrderInfo () {

				let parame = {id: this.id};

				if (this.$route.query.type) {
					parame.type = this.$route.query.type;
				}

				let res = await connectReq.requestGetEInvoiceOrderInfo(this, parame).catch(() => {}).catch(() => {});

				bkLog.log('返回的单据详情：', res);

				if (!res) {
					this.$bk_message.error('Order missing!');
					return;
				}

				let {bill, repayment, compInfo, einvoice} = res;

				let orderInfo = parame.type == 'repayment' ? repayment : bill;

				orderInfo.billType = parame.type;

				orderInfo.compName = compInfo.compName;

				this.orderInfo = orderInfo;

				this.einvoiceInfo = einvoice;
				this.compInfo = compInfo;

				let priceUnitText = '$';

				if (einvoice && [1, 2].indexOf(einvoice.status) != -1) {
					this.showSuccessFlag = true;
				} else {
					if (einvoice.status == 3 && einvoice.customer) { // 无效的 把原输入载入

						let {customer} = einvoice;

						bkLog.log('customer:::', customer);

						Object.assign(this.customerInfo, customer);
					}

					this.showSuccessFlag = false;
				}

				bkLog.log('einvoiceInfo:::', einvoice);
			},

			async requestGetDictInfo () {
				let res = await baseReq.requestPostDictByTypeCode(this, ['intMobileCd', 'currency']).catch(() => {});

				this.dictInfo = res || {};
				bkLog.log('字典res:', res);
			}
		}
	};
</script>

<style lang="less">
@import './e-invoice.less';

.e-invoicePage {

  .view-success {
    text-align: center;
    padding-top: 20vh;

    > .view-title {
      padding-top: 90px;
      .configImgUrlBc('Def_Image_EInvoiceSuccess.png', #fff, center top / 64px no-repeat);
    }
  }

  .view-languageName {
    margin-top: 4px;
    margin-right: -12px;
    float: right;
    height: 32px;
    background: #eee;
    border-radius: 16px;
    padding: 0 12px;
    text-align: center;
    line-height: 32px;
    max-width: 120px;

    > .bk-icon {
      font-size: 24px;
      color: var(--color-main);
      line-height: 32px;
      vertical-align: bottom;
      margin-right: 4px;
    }
  }

  .view-form {
    height: 100%;
    padding: 0 16px calc(120px + env(safe-area-inset-bottom)) 16px;
    overflow-y: auto;

    > .bk-view {
      //margin-bottom: 16px;
    }

    .must {
      position: relative;
      padding-left: 12px !important;

      &:after {
        position: absolute;
        left: 0;
        top: 0;
        color: @color-red;
        content: '*';
        width: 5px;
        height: 5px;
      }
    }

    > .view-nationality {

      > .view-title {
        padding: 16px 0;
      }

      > .view-customerType {
        display: flex;
        padding: 4px;
        background: #F8F7F7;
        border-radius: 5px;

        > .view-customerTypeItem {
          flex: 1;
          text-align: center;
          line-height: 40px;
          .fontBloder();
          font-size: 16px;
          color: #666666;
          border-radius: 5px;

          &.select {
            background: var(--color-main);
            color: #fff;
          }
        }
      }

    }

    .view-formGroup {
      padding: 16px 0;

      > .view-formItem {
        position: relative;
        display: flex;
        margin-bottom: 16px;

        &.foreigner-TIN {
          > .view-tipText {
            position: absolute;
            font-size: 12px;
            z-index: 10;
          }
        }


        > .bk-view {
          flex: 1;
          margin-right: 16px;

          &:last-child {
            margin-right: 0;
          }
        }

        > .bk-select {
          &.size-full {
            height: 48px;
            background: #fff!important;

            > .view-value {
              position: relative;
              height: 48px;
              text-align: left;


              .icon-xiajiantou {
                color: #333 !important;
              }

              //&:after {
              //
              //}
            }
          }
        }

        > .bk-input {
          &.size-full {

            input {
              padding: 13px 16px ;
            }
          }
        }
      }

      > .view-emailTip {
        margin-top: -5px;
        font-size: 12px;
        color: @color-text-tip;
        padding-left: 15px;
      }
    }
  }

  > .view-bottom {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100vw;
    background: #fff;
    padding: 16px 16px calc(16px + env(safe-area-inset-bottom)) 16px;
    border: 1px solid #EFE9E5;
    z-index: 100;

    > .bk-button {
      height: 48px;
    }
  }

}


</style>